import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-list-search',
    templateUrl: './list-search.component.html',
    styleUrls: ['./list-search.component.scss'],
})
export class ListSearchComponent implements OnInit, OnChanges {
    @Input() userList: any;
    @Input() isGroupSearch = false;
    @Output() searchResult = new EventEmitter();

    loadedList = [];

    constructor() { }

    ngOnInit() {
        this.loadedList = this.userList;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.userList && !changes.userList.isFirstChange()) {
            if (!changes.userList.previousValue || changes.userList.currentValue.length >= this.loadedList.length) {
                this.loadedList = changes.userList.currentValue;
            }
        }

    }

    getItems(ev) {
        // Reset items back to all of the items
        this.initializeItems();

        // set val to the value of the ev target
        const val = ev.target.value;

        // if the value is an empty string don't filter the items
        if (val && val.trim() !== '') {
            let filtered = [];
            if (this.isGroupSearch) {
                for (let i = 0; i < this.userList.length; i++) {
                    const playerGroup = this.userList[i];

                    const filteredPlayers = this.filterUsers(playerGroup.players, val);

                    if (filteredPlayers.length) {
                        const filteredPlayerGroup = {
                            initial: playerGroup.initial,
                            players: filteredPlayers
                        };
                        filtered.push(filteredPlayerGroup);
                    }
                }
            } else {
                filtered = this.filterUsers(this.userList, val);
            }

            this.userList = filtered;
            this.searchResult.emit(this.userList);
        } else {
            this.searchResult.emit(this.loadedList);
        }
    }

    initializeItems() {
        this.userList = this.loadedList;
    }

    private filterUsers(users, val) {
        return users.filter((user) => {
            let person = user;
            if (user.person) person = user.person;

            return (person['first_name']?.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
                (person['last_name']?.toLowerCase().indexOf(val.toLowerCase()) > -1);
        });
    }
}
